import * as exBootstrap from '../../bootstrap';

// ----------------------------------------------------------------------------

function init(): void {
    // Get elements (tooltip)
    const elements = document.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]');
    // Foreach Elements
    for (const element of elements) {
        // Initialize bootstrap tooltip
        exBootstrap.getInstance('Tooltip', element);
    }
}

// ----------------------------------------------------------------------------

// Create event (ready)
document.addEventListener('DOMContentLoaded', function (): any {
    init();
});

// ----------------------------------------------------------------------------

export default init;
